import { Component, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-dona-chart',
  templateUrl: './dona-chart.component.html'
})
export class DonaChartComponent {
  @ViewChild(BaseChartDirective) grafico: BaseChartDirective; // referencia al objeto chart (para saber más: "ctrl + click" sobre BaseChartDirective)

  // Dona
  public doughnutChartLabels: string[] = ['Download', 'In-Store Sales', 'Mail-Order', 'Custom sales'];
  // public doughnutChartColors: Array<Color> = [{
  //   hoverBorderWidth: 4
  // }];
  public doughnutChartData: Array<any> = [
    { data: [55, 132, 30, 56], borderWidth: [1, 1, 1, 1] }
  ];
  public doughnutChartType: string = 'doughnut';
  public donaChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0, // on load el gráfico no usamos animaciones
      onComplete: function (animation) {
        animation.chart.options.animation.duration = 1000; // luego del on load seteamos la animacion en 1000
      }
    },
    legend: {
      position: 'right',
      labels: {}
    },
    tooltips: {
      // callbacks: {
      //   labelColor: function (tooltipItem, chart) {
      //     var dataset = chart.config.data.datasets[tooltipItem.datasetIndex];

      //     return {
      //       borderColor: dataset.backgroundColor[tooltipItem.index].trim(),
      //       backgroundColor: dataset.backgroundColor[tooltipItem.index].trim()
      //     };
      //   }
      // }
    }
  };

  constructor() { }

  ngOnInit(): void {
    // this.temaService.temaChange.subscribe(temaNuevo => {
    //   this.actualizarColores(temaNuevo);
    // });
  }

  ngAfterViewInit(): void {
    // inicializar grafico con los colores del tema seleccionado
    //this.actualizarColores(this.temaService.getTemaColores());
  }

  // actualizarColores(colores: TemaColores): void {
  //   // si cambia el tema actualizamos el canvas con los nuevos colores
  //   this.donaChartOptions.legend.labels.fontColor = colores.secondary_text;
  //   // this.doughnutChartColors[0].borderColor = [
  //   //   colores.primary_A100,
  //   //   colores.accent_A100,
  //   //   colores.primary_A200,
  //   //   colores.accent_A200];
  //   // this.doughnutChartColors[0].hoverBorderColor = [
  //   //   colores.disabled_button,
  //   //   colores.disabled_button,
  //   //   colores.disabled_button,
  //   //   colores.disabled_button];
  //   // this.doughnutChartColors[0].backgroundColor = [
  //   //   colores.primary_3_A100,
  //   //   colores.accent_3_A100,
  //   //   colores.primary_7_A200,
  //   //   colores.accent_7_A200];
  //   // this.doughnutChartColors[0].hoverBackgroundColor = [
  //   //   colores.primary_A100,
  //   //   colores.accent_A100,
  //   //   colores.primary_A200,
  //   //   colores.accent_A200];

  //   // aplicar los options del grafico  
  //   this.grafico.ngOnInit();
  // }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }
}
